module.exports = __webpack_public_path__ + "static/media/img_txt_section02_1.45e326fe.png";